import { useState, useEffect } from 'react';
import { FiSettings, FiMoon, FiSun } from 'react-icons/fi';

import styles from './DashboardHeader.module.css';

const DashboardHeader = ({ user, onOptionsClick }) => {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem('theme') !== 'light'
  );

  useEffect(() => {
    document.body.dataset.theme = darkMode
      ? 'dark'
      : 'light';

    localStorage.setItem(
      'theme',
      darkMode ? 'dark' : 'light'
    );
  }, [darkMode]);

  return (
    <header className={styles.header}>
      <div className={styles.user}>
        {user?.avatar_emoji} {user?.tagname}
      </div>

      <div className={styles.actions}>
        <button
          className={styles.iconBtn}
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode ? <FiSun /> : <FiMoon />}
        </button>

        <button
          className={styles.iconBtn}
          onClick={onOptionsClick}
        >
          <FiSettings />
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;